/* FAQ page accordion (sections/bt-page-faq.liquid). Mirrors the useState logic of
   eu-hydrogen/app/routes/($locale).faq.tsx: one item open at a time, clicking the open item closes it.
   The class names below are the same literals the Liquid section renders for both states. */
(function () {
  'use strict';

  function setOpen(item, open) {
    var button = item.querySelector('[data-bt-faq-button]');
    var chevron = item.querySelector('[data-bt-faq-chevron]');
    var panel = item.querySelector('[data-bt-faq-panel]');
    if (button) button.setAttribute('aria-expanded', String(open));
    if (chevron) chevron.classList.toggle('rotate-180', open);
    if (panel) {
      panel.classList.toggle('max-h-[600px]', open);
      panel.classList.toggle('pb-5', open);
      panel.classList.toggle('max-h-0', !open);
    }
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-bt-faq]'), function (list) {
    list.addEventListener('click', function (event) {
      var button = event.target.closest('[data-bt-faq-button]');
      if (!button || !list.contains(button)) return;
      var current = button.closest('[data-bt-faq-item]');
      var wasOpen = button.getAttribute('aria-expanded') === 'true';
      Array.prototype.forEach.call(list.querySelectorAll('[data-bt-faq-item]'), function (item) {
        setOpen(item, item === current && !wasOpen);
      });
    });
  });
})();
